// extracted by mini-css-extract-plugin
export default {"benefits":"x0RhiEAKBRV2qHVFTUBQ","desktopGrid":"Q5SS72tK0xdA97ElL2Gs","iconHeadline":"xawtaYJ9HYAB3IL4rYyj","savingsIcon":"H72NdZTHstPsdllk_x7F"};